// The language half of the Facebook share payload (B894 Phase 4, owner 2026-08-20).
//
// A multi-group spree is ONE publication — one sessionId, one Activity dot, one
// registered permalink. So "Georgian in the local groups, English in the expat ones"
// must NOT be done by pressing ↗ twice: that is two sessions and two publications, the
// exact link inflation the owner ruled against. The job carries every rendered language
// instead, and fill_facebook's banner picks per group.
//
// Kept out of ShareTab.jsx so the invariants below are testable — the shape of this
// object is half a cross-repo contract, and the other half lives in the extension.

// renders — the endpoint's per-target results: [{ target, text?, ok?, reasons? }].
//   A target that failed its QA gates comes back WITHOUT `text` (the endpoint isolates
//   per-target failure on purpose: fb_ka can cache while fb_en 503s). Those must not
//   reach the extension — an empty composer is worse than one language.
// lang — the target the agent had selected when they pressed.
export function fbShareTexts(renders, lang) {
  const texts = {}
  for (const x of renders || []) if (x && x.text) texts[x.target] = x.text

  // `text` is the unchanged half of the contract: an extension build that has never
  // heard of `texts` reads this and behaves exactly as it does today. If the selected
  // language is the one that failed, fall back to any language we do have rather than
  // staging an empty post — the agent can still switch in the banner on a new build.
  const text = texts[lang] || Object.values(texts)[0] || ''
  const defaultTarget = texts[lang] ? lang : Object.keys(texts)[0] || null
  return { text, texts, defaultTarget }
}
